exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content[data-v-327d7788]{background-color:#ebeff1;padding-bottom:.3rem;padding-left:1.2rem;padding-right:1.2rem}.title[data-v-327d7788]{width:12rem;height:.6rem;color:#000;font-size:.15rem;font-weight:400;font-family:Alibaba PuHuiTi;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.title span[data-v-327d7788]:first-child{color:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-327d7788","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/index/examination.vue
// module id = 224
// module chunks = 0